import { SignaturePadController as controller } from './signaturePad.controller';
import template from './signaturePad.html';

export const signaturePadComponent = {
  name: 'signaturePadComponent',
  restrict: 'E',
  transclude: true,
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    model: '=',
    dataUrl: '<',
    clearable: '<',
    skipCheckAspectRatio: '<',
    theme: '@',
    clearLabel: '@',
    autoCrop: '<',
    clientName: '@',
    mobileSignUrl: '@',
    serviceUrl: '@',
    serviceName: '@',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-signature-pad/src/signaturePad.component.js